var render = function render(){var _vm=this,_c=_vm._self._c;return _c('site-monthly-report',{attrs:{"site-id":_vm.siteId,"report-id":_vm.reportId}})
}
var staticRenderFns = []

export { render, staticRenderFns }